import React, {Component} from "react"
import {Link} from "react-router-dom"
import {Icon, Menu} from "semantic-ui-react"
import api from "../../api"
import {observer} from "mobx-react"
import {Trans} from 'react-i18next'

const {signatureStore} = api

@observer
export default class TopNavigation extends Component {

  render() {
    let order         = api.getOrder()
    let isSubmittable = signatureStore.signaturesOpen.length === 0

    return (
      <div className="top-menu">
        {api.errorCode ? null : <div>
          {api.order.StateCode === "eIsWorkDone" ? <br/> : <Menu inverted>
            <Menu.Item name='home'>
              <Link to="/">
                <Icon name='home'/>
                {order.ExternalId}
              </Link>
            </Menu.Item>

            <Menu.Item name='task'>
              <Link to="/tasks"><Trans i18nKey="general.report">Bericht</Trans></Link>
            </Menu.Item>

            {(isSubmittable) ? <Menu.Item name='task'>
              <Link to="/sign"><Icon name="send"/></Link>
            </Menu.Item> : null}

            <Menu.Item position="right">
              <Link to="/escalate"><Icon name="warning sign"/></Link>
            </Menu.Item>
          </Menu>}
        </div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/TopNavigation.js